<template>
  <ul
    v-if="items.length > 0"
    class="ais-HierarchicalMenu-list  ais-HierarchicalMenu-list--lvl1"
    :class="[
      level > 0 && 'ais-HierarchicalMenu-list--child',
      `ais-HierarchicalMenu-list--lvl${level}`,
    ]"
  >
    <li
      v-for="item in items"
      :key="item.value"
      class="ais-HierarchicalMenu-item"
      :class="[
        item.isRefined && 'ais-HierarchicalMenu-item--selected',
        item.data && item.data.length > 0 && 'ais-HierarchicalMenu-item--parent',
      ]"
    >
      <a
        :href="createUrl(item.value)"
        class="ais-HierarchicalMenu-link"
        :class="[
          item.isRefined && 'ais-HierarchicalMenu-link--selected'
        ]"
        @click.exact.left.prevent="refine(item.value)"
      >
        <span class="ais-HierarchicalMenu-label">{{ item.label }}</span>
        <span class="ais-HierarchicalMenu-count">{{ item.count }}</span>
      </a>
      <SanHierarchicalMenuList
        v-if="item.data"
        :items="item.data"
        :level="level + 1"
        :refine="refine"
        :create-url="createUrl"
      />
    </li>
  </ul>
</template>

<script setup>
import SanHierarchicalMenuList from '@/components/instant-search/SanHierarchicalMenuList.vue'

defineOptions({ name: 'SanHierarchicalMenuList' })
const props = defineProps({
  items: { type: Array, required: true },
  level: { type: Number, required: true },
  refine: { type: Function, required: true },
  createUrl: { type: Function, required: true }
})

</script>
